import debug from 'debug';

const log = debug('app:database');

export function deleteMedia(firebase) {
	return async name => {
		const ref = firebase.storage().ref();
		const task = ref.child(name).delete();

		return task.then(({ ...args }) => log('deleteMedia %O', { name, args })).catch(console.error);
	};
}
